
import Image from "next/image";


const WarrantyDownpaymentCard = () => {
  return (
    <div className={`rounded-3xl bg-white px-7 py-5`}>
      <div className="flex items-center">
        <Image alt="" src={"/assets/images/percentage.png"} width={70} height={70}></Image>
        <div className="ml-3">
          <p className="font-inter text-base font-bold text-primary">Downpayment for all cars</p>
          <p className="font-inter text-base font-bold text-black">1 Year free warranty</p>
        </div>
      </div>
    </div>
  );
};

export default WarrantyDownpaymentCard;
